module.exports = __webpack_public_path__ + "images/emoji/sake.21b124a5d99af78fcf24.png";